// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"e118dc98","605":"7ac2e1e6"}[chunkId] + ".chunk.css";
};